import { sizes } from '@dixa/lib-shared-tokens';
import { RefObject, useCallback, useMemo, useState } from 'react';

type UsePanelMeasurementsResult = {
  /** The measured width of the panel. */
  panelWidth: number | null;
  /** The measured height of the panel. */
  panelHeight: number | null;
  /** The measure height of the panel excluding the header. */
  panelContentHeight: number | null;
};

const panelHeaderHeight = parseInt(sizes.spacer.values[500]);
const panelGap = parseInt(sizes.spacer.values[400]);

/** A hook that returns basic measurements of a panel's DOM element. */
export const usePanelMeasurements = (
  panelRef: RefObject<HTMLDivElement>,
): UsePanelMeasurementsResult => {
  const [panelWidth, setPanelWidth] = useState<number | null>(null);
  const [panelHeight, setPanelHeight] = useState<number | null>(null);
  const [panelContentHeight, setPanelContentHeight] = useState<number | null>(
    null,
  );

  const getPanelMeasurements = useCallback(() => {
    if (panelRef.current) {
      const { width, height } = panelRef.current.getBoundingClientRect();

      setPanelWidth(width);
      setPanelHeight(height);
      setPanelContentHeight(Math.round(height - panelHeaderHeight - panelGap));
    }
  }, [panelRef]);

  useMemo(() => {
    getPanelMeasurements();
  }, [getPanelMeasurements]);

  return useMemo(
    () => ({ panelWidth, panelHeight, panelContentHeight }),
    [panelWidth, panelHeight, panelContentHeight],
  );
};
